import * as React from 'react';
import { Col, Row, Divider } from 'antd';
import { observer } from 'mobx-react';
import * as moment from 'moment';

import { DateView } from 'src/core/ui/date.view';
import { TextView } from 'src/core/ui/text.view';
import { RegionEditorController } from 'src/app/general/regions/parts/region-editor.controller';
import { PlaceEditorController } from 'src/app/general/places/parts/place-editor.controller';
import { ProductServiceTypeEditorController } from 'src/app/products/product-service-types/parts/product-service-type-editor.controller';
import { ProductCategoryEditorController } from 'src/app/products/product-categories/parts/product-category-editor.controller';
import { ProductEditorController } from 'src/app/products/products/parts/product-editor.controller';
import { SearchTaxonomies } from 'src/app/bookings/search/requests/search-taxonomy';

interface SearchAccommodationProps {
	currentSearch: SearchAccommodation;
	fieldsTaxonomy: TaxonomicField[];
	onChangeCategory: (productCategoryId: number) => Promise<void>;
	setBusy(isBusy: boolean);
}

@observer
export class SearchAccommodationView extends React.Component<SearchAccommodationProps, {}> {
	render(): React.ReactNode {
		const model = this.props.currentSearch;
		if (model == null) {
			return null;
		}

		return (
			<Row gutter={16}>
				<Col xs={24} lg={16}>
					<Row gutter={16}>
						<Col xs={24} lg={12}>
							<ProductCategoryEditorController
								mode="edit"
								onChanged={(value) => {
									if (value != null) {
										model.productCategoryId = value.id;
										model.productCategoryDisplayName = value.displayName;
										this.props.onChangeCategory(value.id);
									} else {
										model.productCategoryId = null;
										model.productCategoryDisplayName = null;
										model.productServiceTypeId = null;
										model.productServiceTypeDisplayName = null;
										this.props.onChangeCategory(null);
									}
								}}
								value={model.productCategoryId}
								productType={[1, 5]}
								setBusy={this.props.setBusy}
							/>
						</Col>
						<Col xs={24} lg={12}>
							<ProductServiceTypeEditorController
								categoryId={model.productCategoryId}
								mode={model.productCategoryId ? 'edit' : 'display'}
								onChanged={(value) => {
									model.productServiceTypeId = value != null ? value.id : null;
									model.productServiceTypeDisplayName = value != null ? value.displayName : null;
								}}
								value={model.productServiceTypeId}
								setBusy={this.props.setBusy}
							/>
						</Col>
						<Col xs={24} lg={12}>
							<RegionEditorController
								mode="edit"
								onChanged={(value) => {
									model.regionId = value != null ? value.id : null;
									model.regionName = value != null ? value.displayName : null;
									model.placeId = null;
									model.placeName = null;
								}}
								value={model.regionId}
								setBusy={this.props.setBusy}
							/>
						</Col>
						<Col xs={24} lg={12}>
							<PlaceEditorController
								mode={model.regionId ? "edit" : "display"}
								regionId={model.regionId}
								onChanged={(value) => {
									model.placeId = value != null ? value.id : null;
									model.placeName = value != null ? value.displayName : null;
								}}
								value={model.placeId}
								setBusy={this.props.setBusy}
							/>
						</Col>
						<Col xs={24}>
							<ProductEditorController
								label="Accommodation"
								mode="edit"
								onChanged={(value) => {
									model.productId = value != null ? value.id : null;
									model.productName = value != null ? value.displayName : null;
								}}
								value={model.productId}
								productType={model.productCategoryDisplayName != null && model.productCategoryDisplayName.toLowerCase() == 'room' ? 5 : 1}
								regionId={model.regionId}
								placeId={model.placeId}
								categoryId={model.productCategoryId}
								serviceId={model.productServiceTypeId}
								setBusy={this.props.setBusy}
								afterLoad={this.afterProductLoaded}
							/>
						</Col>
						<Col xs={24}>
							<Divider />
							<SearchTaxonomies
								model={model}
								fieldsTaxonomy={this.props.fieldsTaxonomy}
								setBusy={this.props.setBusy}
							/>
						</Col>
					</Row>
				</Col>
				<Col xs={24} lg={8}>
					<Row gutter={16}>
						<Col xs={24} lg={10}>
							<DateView
								required
								label="Check in"
								mode="edit"
								value={model.startDate}
								onChanged={(newVal) => {
									model.startDate = newVal;
									model.endDate = moment.utc(model.startDate).add(model.nights, 'day').toDate();
								}}
								format="small-date"
								dateUsage="utc"
							/>
						</Col>
						<Col xs={24} lg={10}>
							<DateView
								required
								label="Check out"
								mode="edit"
								value={model.endDate}
								onChanged={(newVal) => {
									model.endDate = newVal;
									model.nights = moment.utc(model.endDate).diff(model.startDate, 'day');
								}}
								format="small-date"
								dateUsage="utc"
							/>
						</Col>
						<Col xs={24} lg={4}>
							<TextView
								label="Nights"
								mode="edit"
								value={model.nights}
								onChanged={(newVal) => {
									model.nights = newVal;
									model.endDate = moment.utc(model.startDate).add(model.nights, 'day').toDate();
								}}
							/>
						</Col>
					</Row>
				</Col>
			</Row>
		);
	}

	private afterProductLoaded = (selected: ProductSummary, options: ProductSummary[]) => {
		if (selected && options.every(e => e.id !== selected.id)) {
			this.props.currentSearch.productId = null;
			this.props.currentSearch.productName = null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/search/requests/search-accommodation.view.tsx